import React from "react";
import { Multiselect } from "multiselect-react-dropdown";

interface props {
  list: any[];
  addOrRemoveItem: (value: any) => void;
  handleSearch: (query: any) => void;
  loading: boolean;
  error: any;
  placeholder: string;
  displayValue: string;
  emptyRecordMsg: string;
  id: string;
  selectionLimit?: number;
  singleSelect?: boolean;
}

export default function AsyncMultiSelectOne({
  addOrRemoveItem,
  handleSearch,
  list,
  error,
  loading,
  displayValue,
  emptyRecordMsg,
  id,
  placeholder,
  selectionLimit,
  singleSelect,
}: props) {
  return (
    <div>
      <div className="bg-[#FBFCFE] dark:bg-[#17202F] p-2">
        <Multiselect
          isObject={true}
          options={list.length > 0 ? list : [{ name: "No Item" }]}
          singleSelect={singleSelect ? singleSelect : false}
          placeholder={placeholder}
          displayValue={displayValue}
          emptyRecordMsg={emptyRecordMsg}
          onSelect={addOrRemoveItem}
          onSearch={handleSearch}
          onRemove={addOrRemoveItem}
          loading={loading}
          id={id}
          style={{
            searchBox: {
              border: "none",
              background: "none",
              width: "100%",
              height: "100%",
              cursor: "pointer",
            },
            optionContainer: {
              background: "rgba(0,150,251,.7)",
              color: "#fff",
            },
          }}
          selectionLimit={selectionLimit}
        />
      </div>
      {error && typeof error === "string" && (
        <small className={"text-red-500"}>{error}</small>
      )}
      {error &&
        Array.isArray(error) &&
        error.map((x) => <small className={"text-red-500"}>{x}</small>)}
    </div>
  );
}
